"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.REQUIRED_PATIENT_ADDRESS_FIELDS = exports.REQUIRED_PATIENT_FIELDS = exports.DEFAULT_MAX_REFERRALS = exports.CrmConnectorStates = exports.CrmConnectorPostMessageEvents = exports.CrmConnectorEvents = void 0;
exports.CrmConnectorEvents = __importStar(require("./events"));
exports.CrmConnectorPostMessageEvents = __importStar(require("./postMessageEvents"));
exports.CrmConnectorStates = __importStar(require("./states"));
exports.DEFAULT_MAX_REFERRALS = 10;
exports.REQUIRED_PATIENT_FIELDS = {
    booking: [
        'email',
        'dateOfBirth',
        'firstName',
        'lastName',
        'gender',
        'phoneNumber',
        'address'
    ],
    referral: []
};
exports.REQUIRED_PATIENT_ADDRESS_FIELDS = {
    booking: ['street1', 'city', 'state', 'zip'],
    referral: []
};
//# sourceMappingURL=index.js.map